import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoginService } from "./login.service";
import { Router } from "@angular/router";
import { ConfigService } from "../config.service";

declare var $: any;
declare var toastr: any;
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  complexForm: FormGroup;
  cityid: any;
  ip: "10.34.453.4.3";
  disableLoginBtn = false;
  constructor(
    fb: FormBuilder,
    private _loginService: LoginService,
    private _router: Router,
    private _cookie: ConfigService
  ) {
    this.complexForm = fb.group({
      email: [null, Validators.required],
      password: [
        null,
        Validators.compose([
          Validators.required
          // Validators.minLength(3),
          // Validators.maxLength(10)
        ])
      ]
    });
  }

  submitForm() {
    $(".lds-dual-ring").show();
    this.disableLoginBtn = true;
    this._loginService
      .login({
        email: this.complexForm.value.email.toLowerCase(),
        password: this.complexForm.value.password,
        ip: this.ip ? this.ip : "10.1.202.2",
        loginType: "dispatcher",
        deviceType: 3,
        userType: "dispatcher"
      })
      .subscribe(
        (res: any) => {
          console.log("login res", res);
          $(".login-form #err").hide();
          let operatorId;
          if (res.data.operatorId == "") {
            operatorId = 0;
            this._cookie.setOperatorId(operatorId);
          } else {
            operatorId = res.data.operatorId;
            this._cookie.setOperatorId(operatorId);
          }
          if (
            res.data.cityId == "" ||
            res.data.cityId == [] ||
            res.data.cityId == null
          ) {
            this.cityid = 0;
            this._cookie.setCityId(this.cityid);
          } else {
            this.cityid = res.data.cityId[0];
            this._cookie.setCityId(this.cityid);
          }
          // this._cookie.setSetting(res.data);
          // this._conf.setItem(res,"token", res.data.token);
          // localStorage.setItem("dev", this.fingerprint);
          this._cookie.setItem(res.data);
          // sessionStorage.setItem("authtoken", res.data.token);
          // sessionStorage.setItem('mqtt', res.data.mqttTopic);
          // sessionStorage.setItem('sid', res.data.sid);
          setTimeout(() => {
            this._router.navigate(["dispatcher"]);
          }, 1000);
          // sessionStorage.setItem('devtoken', res.data.token);
          // sessionStorage.setItem('godsviewMqttCha nnel', res.data.godsviewMqttChannel);
          // this._router.navigate(['dispatcher']);
        },
        err => {
          this.disableLoginBtn = false;
          $(".lds-dual-ring").hide();
          const altMsg = err.error;
          if (err.status >= 500) {
            err.status = 500;
          } else {
            err.status = 400;
          }
          switch (err.status) {
            case 400:
              toastr["error"]("<h5>" + altMsg.message + "</h5>");
              break;
            case 500:
              toastr["error"]("<h5>Internal server error</h5>");
              break;
          }
        }
      );
  }

  ngOnInit() {
    $.get("https://ipapi.co/json/").always(res => {
      if (res.status >= 400 || res.error) {
        $.get("https://ipinfo.io", function () { }, "jsonp").always(resp => {
          this.ip = resp.ip;
          console.log(resp, this.ip);
          this._cookie.setNewCookie("ipinfo", JSON.stringify(res), 3);
          sessionStorage.setItem("ipinfo", JSON.stringify(resp));
        });
      } else {
        this.ip = res.ip;
        console.log(res, this.ip);
        this._cookie.setNewCookie("ipinfo", JSON.stringify(res), 3);
        sessionStorage.setItem("ipinfo", JSON.stringify(res));
      }
    });
    $(".lds-dual-ring").hide();
    toastr.options = {
      // toast messages settings
      newestOnTop: false,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "3000",
      hideDuration: "1000",
      timeOut: "6000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut"
    };

    $("input").on("focusout", function () {
      $(this).each(function (i, e) {
        if ($(e).val() !== "") {
          $(e).addClass("not-empty");
        } else {
          $(e).removeClass("not-empty");
        }
      });
    });
    this.complexForm.reset();
  }
}
